/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioClasesTecnicasCV from './controladorVista/formularioClasesTecnicasCV';
import TablaClasesTecnicasCV from './controladorVista/tablaClasesTecnicasCV';
import { estadoIncial, reductor } from './reductorClasesTecnicas';

const ClasesTecnicas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaClasesTecnicasCV />
        <FormularioClasesTecnicasCV />
    </ProveedorEstado>
);

export default ClasesTecnicas;
